var React = require('react');

function RoundCross (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".unquie{fill:#f56565;}")),React.createElement("path",{"id":"path-1","className":"unquie","d":"M9,18a9,9,0,1,1,9-9A9,9,0,0,1,9,18Zm0-.9A8.1,8.1,0,1,0,.9,9h0A8.07,8.07,0,0,0,9,17.1Z","key":1}),React.createElement("polygon",{"className":"unquie","points":"9.9 9 12.5 11.7 11.7 12.5 9 9.9 6.3 12.5 5.5 11.7 8.1 9 5.5 6.3 6.3 5.5 9 8.1 11.7 5.5 12.5 6.3 9.9 9","key":2})]);
}

RoundCross.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = RoundCross;

RoundCross.default = RoundCross;
